(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '@material-ui/core/styles', '@material-ui/core/Input', '@material-ui/core/InputLabel', '@material-ui/core/FormControl', '@material-ui/core/FormHelperText', '../../styles/colors', '../../elements/typography'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('@material-ui/core/styles'), require('@material-ui/core/Input'), require('@material-ui/core/InputLabel'), require('@material-ui/core/FormControl'), require('@material-ui/core/FormHelperText'), require('../../styles/colors'), require('../../elements/typography'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.styles, global.Input, global.InputLabel, global.FormControl, global.FormHelperText, global.colors, global.typography);
    global.TextInput = mod.exports;
  }
})(this, function (exports, _react, _styles, _Input, _InputLabel, _FormControl, _FormHelperText, _colors, _typography) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var React = _interopRequireWildcard(_react);

  var _Input2 = _interopRequireDefault(_Input);

  var _InputLabel2 = _interopRequireDefault(_InputLabel);

  var _FormControl2 = _interopRequireDefault(_FormControl);

  var _FormHelperText2 = _interopRequireDefault(_FormHelperText);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var TextInput = function TextInput(_ref) {
    var testId = _ref['data-testid'],
        autoFocus = _ref.autoFocus,
        classes = _ref.classes,
        disabled = _ref.disabled,
        endAdornment = _ref.endAdornment,
        error = _ref.error,
        errorText = _ref.errorText,
        fullWidth = _ref.fullWidth,
        id = _ref.id,
        label = _ref.label,
        multiline = _ref.multiline,
        name = _ref.name,
        onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        placeholder = _ref.placeholder,
        required = _ref.required,
        startAdornment = _ref.startAdornment,
        type = _ref.type,
        value = _ref.value,
        readOnly = _ref.readOnly,
        onKeyUp = _ref.onKeyUp,
        onKeyDown = _ref.onKeyDown,
        defaultValue = _ref.defaultValue,
        className = _ref.className,
        InputLabelProps = _ref.InputLabelProps,
        inputProps = _ref.inputProps;
    return React.createElement(
      _FormControl2.default,
      {
        fullWidth: fullWidth,
        className: className,
        classes: fullWidth ? {} : { root: classes.defaultInputWidth }
      },
      label && React.createElement(
        _InputLabel2.default,
        InputLabelProps,
        React.createElement(
          _typography.Label,
          null,
          label
        )
      ),
      React.createElement(_Input2.default, {
        'data-testid': testId,
        inputProps: inputProps,
        classes: {
          root: classes.inputValueText,
          inputTypeSearch: classes.inputTypeSearch,
          underline: classes.cssUnderline,
          error: classes.error
        },
        onChange: onChange,
        type: type,
        autoFocus: autoFocus,
        onFocus: onFocus,
        onBlur: onBlur,
        fullWidth: fullWidth,
        placeholder: placeholder,
        multiline: multiline,
        name: name,
        disabled: disabled,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        defaultValue: defaultValue,
        readOnly: readOnly,
        error: error,
        endAdornment: endAdornment,
        startAdornment: startAdornment,
        value: value,
        required: required
      }),
      error && errorText && React.createElement(
        _FormHelperText2.default,
        null,
        React.createElement(
          _typography.Note,
          { style: { color: _colors2.default.dragon } },
          errorText
        )
      )
    );
  };

  TextInput.defaultProps = {
    autoFocus: false,
    disabled: false,
    endAdornment: null,
    error: false,
    errorText: '',
    fullWidth: false,
    label: null,
    multiline: false,
    placeholder: null,
    startAdornment: null,
    type: 'text',
    name: '',
    required: false,
    InputLabelProps: {},
    inputProps: {}
  };

  var styles = {
    defaultInputWidth: {
      width: '26.25rem'
    },
    inputValueText: {
      fontFamily: 'Proxima Nova, Arial, Helvetica, sans-serif'
    },
    inputTypeSearch: {
      height: '2.1875em'
    },
    cssLabel: {
      '&$cssFocused': {
        color: _colors2.default.prussian
      }
    },
    cssFocused: {},
    cssUnderline: {
      '&:after': {
        borderBottomColor: _colors2.default.prussian
      }
    },
    error: {
      '&$error:after': {
        borderBottomColor: _colors2.default.dragon
      }
    }
  };

  exports.default = (0, _styles.withStyles)(styles)(TextInput);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Inputs/TextInput.js
// module id = 567
// module chunks = 0